<template>
    <div>
        <div class="add-product-modal-overlay" @click="close()"></div>

        <div class="add-product-modal" :class="{ 'bp-simple': $v2 && product.category_id != 1 }" v-if="loaded && !showIngredients && !showAdditionalSauces">
            <div v-if="!finished" class="add-product-modal__head">
                <img class="add-product-modal__head-img" :src="product.thumbnail" :alt="product.title">

                <div class="add-product-modal__head-info">
                    <div class="add-product-modal-close-section">
                        <div class="add-product-modal-title" style="padding-left: 0;" v-if="!finished">
                            {{ product.title }}
                            <span v-if="product.category_id == 1 && this.sizeName">({{ this.sizeName }})</span>
                            <span v-if="product.category_id != 1 && !$v2">({{ product.volume }} ml)</span>
                        </div>
                        <!-- Новий дизайн: кругла світла кнопка в кутку вікна замість чорного квадрата -->
                        <button v-if="$v2" type="button" class="bp-modal-close" aria-label="Закрити" @click="close()"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>
                        <inline-svg v-else src="/img/icons/close-box.svg" class="add-product-modal-close-icon" :fill="this.$store.state.nightMode ? 'white' : 'black'" @click="close()"></inline-svg>
                    </div>
                    <div class="add-product-modal-products" v-if="product.category_id == 1">
                        <span v-if="product.weight_30 > 0 || product.weight_50 > 0" class="product-box-description__weight">{{
                                sizeName == '30 см' ? product.weight_30 : product.weight_50
                        }} г – </span>
                        {{ product.description }}
                    </div>
                    <!-- Новий дизайн: напій чи снек — вага або об'єм перед описом, як на картці -->
                    <div class="add-product-modal-products" v-if="$v2 && product.category_id != 1 && (simpleMeta || product.description)">
                        <span v-if="simpleMeta" class="product-box-description__weight">{{ simpleMeta }}<template v-if="product.description"> – </template></span>{{ product.description }}
                    </div>
                </div>
            </div>

            <div v-if="!finished" class="add-product-modal__quantity">
                <div class="add-product-modal-buttons-box">
                    <div class="add-product-modal__quantity-price">{{ getPrice() }} грн</div>
                </div>

                <div class="quantity-box">
                    <div class="quanity-button quanity-button--minus" @click="changeQuanity('minus')"
                         :tabindex="$v2 ? 0 : null" :role="$v2 ? 'button' : null" :aria-label="$v2 ? 'Менше' : null"
                         @keydown.enter.space.prevent="changeQuanity('minus')">
                        <span v-if="$v2" class="bp-qty-ic" v-html="icons.minus"></span>
                        <template v-else>-</template>
                    </div>
                    <input class="quanity-input" type="text" v-model="quanity" :aria-label="$v2 ? 'Кількість' : null">
                    <div class="quanity-button quanity-button--plus" @click="changeQuanity('plus')"
                         :tabindex="$v2 ? 0 : null" :role="$v2 ? 'button' : null" :aria-label="$v2 ? 'Більше' : null"
                         @keydown.enter.space.prevent="changeQuanity('plus')">
                        <span v-if="$v2" class="bp-qty-ic" v-html="icons.plus"></span>
                        <template v-else>+</template>
                    </div>
                </div>
            </div>

            <div v-if="!finished" class="add-product-modal__quantity">
                <div class="add-product-modal__total-price" style="margin: -6px 0 0 auto;">Сума: <span style="color: #AB2321;">{{ getPrice() * this.quanity }} грн</span></div>
            </div>

            <div v-if="!finished" class="add-product-modal-products-container">
                <!-- Новий дизайн: той самий перемикач 30 / 50, що на картці (вибраний темний) -->
                <div v-if="$v2 && product.category_id == 1 && product.show_50 && product.show_30" class="bp-size bp-size--modal" role="group" aria-label="Розмір">
                    <button type="button" v-for="size in sizes" :key="size.name" :aria-pressed="size.selected ? 'true' : 'false'" @click="changeSize(size)">{{ size.name }}</button>
                </div>
                <div class="size-box" v-else-if="product.category_id == 1 && product.show_50 && product.show_30">
                    <div v-for="size in sizes" :key="size.name" :class="size.selected ? 'size-selected' : 'size'" @click="changeSize(size)"
                         :tabindex="$v2 ? 0 : null" :role="$v2 ? 'button' : null" :aria-pressed="$v2 ? String(!!size.selected) : null"
                         @keydown.enter.space.prevent="changeSize(size)">
                        {{ size.name }}
                    </div>
                </div>

                <!-- Новий дизайн: швидкі додатки — ті самі «чипи», що на картці -->
                <div v-if="$v2 && product.category_id == 1" class="bp-chips bp-chips--modal" role="group" aria-label="Додати до піци">
                    <button type="button" role="checkbox" class="bp-chip" v-for="ingredient in mainIngredients" :key="ingredient.id"
                            :aria-checked="checkSelectedIngredient(ingredient.id) ? 'true' : 'false'" @click="addIngredientManual(ingredient.id)">
                        <span class="bp-chip__box" aria-hidden="true">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M5 12.5l4.5 4.5L19 7.5"/>
                            </svg>
                        </span>
                        <span class="bp-chip__t">{{ ingredient.title }}</span>
                    </button>
                </div>
                <ul class="ingredients__list" v-else-if="product.category_id == 1">
                    <li v-for="ingredient in mainIngredients" :key="ingredient.id"
                        :class="(checkSelectedIngredient(ingredient.id) ? 'ingredient-button-selected' : '') + ' ingredient-button ingredients__item'" @click="addIngredientManual(ingredient.id)">

                        <inline-svg class="checked-mark" src="/img/icons/check-mark.svg" width="20" height="20"></inline-svg>

                        <i class="unchecked-mark"></i>

                        {{ ingredient.title }}
                    </li>
                </ul>

                <div v-if="product.category_id == 1" class="ingredients">
                    <div class="add-product-modal-title" :class="{ 'bp-rail-head': $v2 }">
                        Додаткові інгредієнти
                        <span v-if="$v2" class="bp-rail-nav"><button type="button" aria-label="Гортати назад" @click="scrollRail($event, -1)"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg></button><button type="button" aria-label="Гортати далі" @click="scrollRail($event, 1)"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg></button></span>
                    </div>
                    <div class="ingredients-section">
                        <div v-for="ingredient in filteredIngredients" :key="ingredient.id"
                             :class="ingredient.selected ? 'ingredient-box ingredient-box-selected' : 'ingredient-box'"
                             @click="addIngredient(ingredient)"
                             :tabindex="$v2 ? 0 : null" :role="$v2 ? 'checkbox' : null" :aria-checked="$v2 ? String(!!ingredient.selected) : null"
                             :aria-label="$v2 ? ingredient.title + ', ' + (sizeName == '30 см' ? ingredient.price : ingredient.price * 2) + ' грн' : null"
                             @keydown.enter.space.prevent="addIngredient(ingredient)">
                            <img :src="ingredient.thumbnail" class="ingredient-box__img">
                            <div class="ingredient-box__content">
                                <div v-html="ingredient.title" style="font-weight: bold"></div>
                                <div style="color: #AB2321; font-weight: 700">
                                    {{ sizeName == '30 см' ? ingredient.price : ingredient.price * 2 }} грн
                                </div>
                            </div>

                            <div style="position: absolute;top: 0;right: 0;padding-top: 2px;padding-right: 7px;"></div>
                        </div>
                    </div>
                    <div v-if="!$v2 && product.additionaIngredients.length" class="selected-ingredients">
                        <span class="selected-ingredients__title">Додатки: </span>
                        <span v-for="(ingredient, index) in product.additionaIngredients" :key="ingredient.index" v-if="isFirstIngredient(index, ingredient.id)"><span v-if="index != 0">, </span>{{ ingredient.title }}<span v-if="countSelectedIngredient(ingredient.id) > 1"> x{{ countSelectedIngredient(ingredient.id)}}</span>
                        </span>
                    </div>
                </div>

                <div v-if="product.category_id == 1" class="sauces">
                    <div class="add-product-modal-title" :class="{ 'bp-rail-head': $v2 }">
                        Додатковий соус
                        <span v-if="$v2" class="bp-rail-nav"><button type="button" aria-label="Гортати назад" @click="scrollRail($event, -1)"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg></button><button type="button" aria-label="Гортати далі" @click="scrollRail($event, 1)"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg></button></span>
                    </div>
                    <div class="ingredients-section">
                        <div v-for="sauce in sauces" :key="sauce.id" class="ingredient-box" :class="{ 'ingredient-box-selected': $v2 && getIngredientQuanity(sauce.id) > 0 }">
                            <div>
                                <img :src="sauce.thumbnail" class="ingredient-box__img" @click="addSauceManual(sauce.id)">
                                <div class="ingredient-box__content">
                                    <div v-html="$v2 ? sauceName(sauce.title) : sauce.title" style="font-weight: bold"></div>
                                    <div style="color: #AB2321;font-weight: 700">
                                        {{ sizeName == '30 см' ? sauce.price : sauce.price * 2 }} грн
                                    </div>
                                    <div class="quantity-box">
                                        <div class="quanity-button quanity-button--minus" @click="changeSauceQuanity('minus', sauce.id)"
                                             :tabindex="$v2 ? 0 : null" :role="$v2 ? 'button' : null" :aria-label="$v2 ? 'Менше соусу' : null"
                                             @keydown.enter.space.prevent="changeSauceQuanity('minus', sauce.id)">
                                            <span v-if="$v2" class="bp-qty-ic" v-html="icons.minus"></span>
                                            <template v-else>-</template>
                                        </div>
                                        <div class="quanity-input">{{ getIngredientQuanity(sauce.id) }}</div>
                                        <div class="quanity-button quanity-button--plus" @click="changeSauceQuanity('plus', sauce.id)"
                                             :tabindex="$v2 ? 0 : null" :role="$v2 ? 'button' : null" :aria-label="$v2 ? 'Більше соусу' : null"
                                             @keydown.enter.space.prevent="changeSauceQuanity('plus', sauce.id)">
                                            <span v-if="$v2" class="bp-qty-ic" v-html="icons.plus"></span>
                                            <template v-else>+</template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Новий дизайн: перелік додатків і кнопка закріплені внизу вікна (sticky), тож «В кошик» видно завжди -->
                <div class="add-to-card-bar" style="width: 100%;">
                    <!-- Новий дизайн: перелік додатків над кнопкою, а не між рядами — щоб соуси не стрибали вниз, коли він з'являється -->
                    <div v-if="$v2 && product.category_id == 1 && product.additionaIngredients.length" class="selected-ingredients bp-sel-add">
                        <span class="bp-add-ic" v-html="icons.cheese"></span><span class="selected-ingredients__title">Додатки: </span>
                        <span v-for="(ingredient, index) in product.additionaIngredients" :key="ingredient.index" v-if="isFirstIngredient(index, ingredient.id)"><span v-if="index != 0">, </span>{{ ingredient.title }}<span v-if="countSelectedIngredient(ingredient.id) > 1"> x{{ countSelectedIngredient(ingredient.id)}}</span>
                        </span>
                    </div>

                    <button class="add-to-card-button" @click="addToCart()">
                        <!-- Новий дизайн: сумка з плюсом зліва від тексту -->
                        <template v-if="$v2"><inline-svg class="bp-btn-ic" src="/img/icons/shopping-cart.svg" width="20" height="20" fill="currentColor" aria-hidden="true"></inline-svg><span>В кошик</span></template>
                        <template v-else>В кошик</template>
                    </button>
                </div>
            </div>

            <div v-if="finished" class="finished-section">
                <div>
                    Дякуємо!
                </div>
                <div style="margin-top: 14px">
                    <button type="button" class="btn btn-light" @click="routerToRoute('pizza')">Повернутись в меню</button>
                </div>
                <div style="margin-top: 14px">
                    <router-link :to="{name: 'cart', params: {locationCity: this.$route.params.locationCity}}" :params="{ locationCity: this.$route.params.locationCity }">
                        <button class="add-to-card-button make-order">Оформити замовлення
                        </button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import InlineSvg from 'vue-inline-svg';
import { ICONS } from '@/v2icons';
import { sortMainIngredients } from '@/menuSort';

export default {
    components: {
        InlineSvg
    },
    // Новий дизайн: розмір і швидкі додатки, вибрані на картці піци ({ size, ingredients: [id] })
    props: {
        preset: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            icons: ICONS,
            product: {},
            quanity: 1,
            sizes: [
                {
                    'name': '30 см', 'selected': true, 'selector': 'price_30', 'size': 30
                },
                {
                    'name': '50 см', 'selected': false, 'selector': 'price_50', 'size': 50
                }
            ],
            ingredients: [],
            filteredIngredients: [],
            sauces: [],
            sizeName: '30 см',
            sizeSelector: 'price_30',
            showIngredients: false,
            showAdditionalSauces: false,
            loaded: false,
            finished: false
        }
    },

    computed: {
        // Новий дизайн: «75 г» для снека, «1000 мл» для напою; якщо об'єм уже в назві чи описі («1 літр») — не дублюємо
        simpleMeta() {
            const p = this.product;
            if (p.is_beverage == 1) {
                const ml = parseInt(p.volume);
                if (!(ml > 0) || /\d\s*(л|літр|ml|мл)/i.test((p.title || '') + ' ' + (p.description || ''))) return '';
                return ml + ' мл';
            }
            return p.weight_30 > 0 ? p.weight_30 + ' г' : (p.weight_50 > 0 ? p.weight_50 + ' г' : '');
        },

        // Швидкі кнопки (сир х2, вершки…) — у порядку застосунку, src/menuSort.js
        mainIngredients() {
            return sortMainIngredients(this.ingredients.filter(e =>
                e.show_main && (this.sizeName == '30 см' || e.available_50) && !(e.is_black && this.product.is_black)));
        }
    },

    methods: {
        // Новий дизайн: у ряду під заголовком «Додатковий соус» слово «соус» не повторюємо («BBQ соус» → «BBQ»)
        sauceName(title) {
            return String(title).replace(/(^|\s)соус(?=\s|$)/gi, ' ').replace(/\s+/g, ' ').trim() || title;
        },
        // Новий дизайн: стрілки над рядом карток гортають його на ширину видимої частини
        scrollRail(e, dir) {
            const rail = e.currentTarget.closest('.add-product-modal-title').nextElementSibling;
            rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
        },
        close() {
            this.$emit('close');
        },

        getPrice() {
            let price = this.product.category_id == 1 ? this.product[this.sizeSelector] : this.product.price;
            this.product.additionaIngredients.forEach(ingredient => {
                price += parseInt(ingredient.price);
            });

            return price;
        },

        getPriceWithoutAdditionals() {
            return this.product.category_id == 1 ? this.product[this.sizeSelector] : this.product.price;
        },

        changeSize(size) {
            // Новий дизайн: вибрані додатки не скидаємо, а додаємо наново під новий розмір (ціна ×2 і «(велика піца)»).
            // Відпадають лише швидкі, яких для 50 см немає; позначки на картках знімаємо, щоб не лишались «вибраними» без додатка
            const keep = this.$v2 ? (this.product.additionaIngredients || []).map(e => e.id) : [];
            if (this.$v2) this.ingredients.forEach(e => { if (e.selected) this.$set(e, 'selected', false); });

            this.sizes.forEach(e => {
                e.selected = false;
            });

            this.product.additionaIngredients = [];
            this.sizeName = size.name;
            this.sizeSelector = size.selector;
            size.selected = true;

            keep.forEach(id => {
                const ingredient = this.ingredients.find(e => e.id == id);
                if (!ingredient || (size.name == '50 см' && ingredient.show_main && !ingredient.available_50)) return;
                if (this.checkSelectedIngredient(id)) this.addSauce(ingredient);
                else this.addIngredient(ingredient);
            });
            if (this.$v2) this.$forceUpdate();
        },

        countSelectedIngredient(ingredientId) {
            let count = 0;
            this.product.additionaIngredients.forEach(e => {
                if(e.id == ingredientId) {
                    count++;
                }
            });

            return count;
        },

        isFirstIngredient(ingredientIndex, ingredientId) {
            let isFirstIngredient = null;
            this.product.additionaIngredients.forEach((item, index) => {
                console.log(ingredientIndex)
                if(item.id == ingredientId && isFirstIngredient == null) {
                    if(ingredientIndex == index) {
                        isFirstIngredient = true;
                    }
                    else {
                        isFirstIngredient = false;
                    }
                }
            });
            console.log(isFirstIngredient);

            return isFirstIngredient;
        },

        addIngredient(ingredient) {
            let index = this.ingredients.findIndex(e => e.id == ingredient.id);
            if (!this.ingredients[index].selected) {
                if (this.sizeName == '50 см') {
                    ingredient = JSON.parse(JSON.stringify(ingredient));
                    ingredient.title = ingredient.title + ' (велика піца)';
                    ingredient.price = ingredient.price * 2;
                }
                this.$set(this.ingredients[index], 'selected', true);
                this.product.additionaIngredients.push(ingredient);
                return;
            }

            if (this.ingredients[index].selected) {
                this.$set(this.ingredients[index], 'selected', false);
                let ingredientIndex = this.product.additionaIngredients.findIndex(e => e.id == ingredient.id);
                this.product.additionaIngredients.splice(ingredientIndex, 1);

            }
        },

        checkSelectedIngredient(id) {
            let ingredient = this.product.additionaIngredients.findIndex(e => e.id == id);
            return ingredient == -1 ? false : true;
        },

        addIngredientManual(id) {
            let index = this.ingredients.findIndex(e => e.id == id);
            let ingredient = this.ingredients[index];
            this.addIngredient(ingredient);
            this.$forceUpdate();
        },

        addSauceManual(id) {
            let index = this.ingredients.findIndex(e => e.id == id);
            let ingredient = this.ingredients[index];
            this.addIngredient(ingredient);
            this.$forceUpdate();
        },

        addSauce(ingredient) {
            let index = this.ingredients.findIndex(e => e.id == ingredient.id);
            this.$set(this.ingredients[index], 'selected', true);

            if (this.sizeName == '50 см') {
                ingredient = JSON.parse(JSON.stringify(ingredient));
                ingredient.title = ingredient.title + " (велика піца)";
                ingredient.price = ingredient.price * 2;
            }

            this.product.additionaIngredients.push(ingredient);
            this.$forceUpdate();
        },

        changeSauceQuanity(way, id) {
            if (way == 'plus') {
                let index = this.ingredients.findIndex(e => e.id == id);
                let ingredient = this.ingredients[index];
                this.addSauce(ingredient);
            }
            else if (way == 'minus') {
                let index = this.ingredients.findIndex(e => e.id == id);
                let ingredient = this.ingredients[index];
                this.$set(this.ingredients[index], 'selected', false);
                let ingredientIndex = this.product.additionaIngredients.findIndex(e => e.id == ingredient.id);
                this.product.additionaIngredients.splice(ingredientIndex, 1);
                this.$forceUpdate();
            }
        },

        getIngredientQuanity(id) {
            let ingredients = this.product.additionaIngredients.filter(e => e.id == id);
            return ingredients.length;
        },

        getIngredientInfo(id) {
            let ingredient = this.ingredients.find(e => e.id == id);
            return ingredient;
        },

        addToCart() {
            dataLayer.push({
                'event': 'addToCart'
            });

            this.product.quanity = this.quanity;
            if(this.product.category_id == 1) {
                this.product.size = this.sizeName;
            }
            else if(this.product.category_id == 2) {
                this.product.size = this.product.volume + ' ml';
            }
            else {
                if(this.product.volume > 0) {
                    this.product.size = this.product.volume + ' г';
                }
                else if(this.product.weight_30 > 0) {
                    this.product.size = this.product.weight_30 + ' г';
                }
            }

            this.product.price = this.getPrice();
            this.product.priceWithoutAdditionals = this.getPriceWithoutAdditionals();
            this.$store.commit('addToCart', this.product);
            // Новий дизайн: без «Дякуємо!» — закриваємо вікно, а картка показує «Додано»
            if (this.preset) {
                this.$emit('added');
                this.close();
                return;
            }
            this.finished = true;
            if (window.innerWidth > 1024) {
                this.close();
            }
        },

        routerToRoute(name) {
            this.close();
            this.$router.push({name: name, params: {location_city: this.$route.params.locationCity}});
        },

        changeQuanity(way) {
            if (way == 'minus') {
                if (this.quanity == 1) {
                    return;
                }
                this.quanity--;
            }
            else if (way == 'plus') {
                this.quanity++;
            }
        }
    },

    mounted() {
        this.product = this.$store.state.currentProduct;
        this.product.additionaIngredients = [];

        if (!this.product.price_30) {
            this.changeSize(this.sizes[1]);
        }

        axios.get(`${Vue.prototype.SERVER_URL}/api/${JSON.parse(localStorage.getItem('locationCityId'))}/ingredients`).then(response => {
            this.ingredients = response.data;
            this.filteredIngredients = this.ingredients.filter(e => e.show == 1);
            this.sauces = this.ingredients.filter(e => e.is_sauce == 1);
            if (this.preset) {
                // Тими самими методами, що й кліки у вікні
                if (this.preset.size == '50 см' && this.sizeName != '50 см') {
                    this.changeSize(this.sizes[1]);
                }
                this.preset.ingredients.forEach(id => this.addIngredientManual(id));
            }
            this.loaded = true;
        });
    }
}
</script>

<style>
.add-product-modal-overlay {
    width: 100%;
    height: 100%;
    background-color: rgba(70, 70, 70, 0.9);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
}

.add-product-modal {
    z-index: 101;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    display: flex;
    flex-direction: column;
    align-items: center;

    height: 96%;
    min-height: 563px;
    width: 90%;
    max-width: 560px;

    padding: 34px 40px 21px;
    border: 1px solid #eee;
    border-radius: 8px;
    background-color: #fff;
    overflow-y: auto;
}

.add-product-modal__head {
    display: flex;
    width: 100%;
    margin-bottom: 30px;
}

.add-product-modal__head-img {
    max-height: 120px;
}

.add-product-modal__head-info {
    width: 100%;
    padding-left: 14px;
}

.add-product-modal-close-section {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.add-product-modal-close-icon {
    cursor: pointer
}

.add-product-modal-title {
    margin-bottom: 8px;

    font-size: 1.2rem;
    font-weight: 700;
    text-align: left;
}

.add-product-modal__quantity {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    margin-bottom: 20px;
}

.add-product-modal__quantity-price {
    font-size: 1.15rem;
    font-weight: 700;
}

.add-product-modal__total-price {
    font-size: 1.15rem;
    font-weight: 700;
}

.quantity-box {
    display: flex;
    justify-content: center;
}

.add-product-modal__quantity input,
.add-product-modal__quantity input:focus,
.add-product-modal__quantity input:active {
    width: 54px;
    border: unset !important;
    text-align: center;
    background: unset;
    color: black;
    outline: none;
}

.quanity-input {
    width: 54px;
    text-align: center;
}

.dark input.quanity-input {
    color: white;
}

.quanity-button {
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;

    height: 24px;
    width: 24px;

    border: 1px solid #AB2321;
    border-radius: 3px;
    color: white;
    cursor: pointer;
}

.quanity-button--minus {
    color: black;
}

.quanity-button--plus {
    background-color: #AB2321;
}

.add-product-modal-products-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    width: 100%;
}

.add-product-modal-products {
    width: 100%;

    color: black;
    font-size: 0.9rem;
    text-align: left;
}

.add-product-modal-checkout-section {
    width: 100%;
    margin-top: auto;
    padding: 14px;
}

.add-product-modal-buttons-box {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
}

.size-box {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;

    margin-bottom: 24px;

    border-radius: 6px;
    text-align: center;
    background: #D8D8D8;

    .size-selected, .size {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 50%;
        height: 40px;

        margin: 0;
        border: unset;
        border-radius: 6px;
        line-height: 40px;
    }
}

.size-selected {
    color: white;
    background: #AB2321;
    font-weight: 700;
}

.size {
    background: #D8D8D8;
    cursor: pointer;
}

.finished-section {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
}

.make-order {
    display: none;
}

.ingredient-button {
    display: flex;
    width: fit-content;

    padding: 6px 12px;
    cursor: pointer;
}

.ingredients {
    width: 100%;
    margin-bottom: 18px;
}

.sauces {
    width: 100%;

    .ingredient-box {
        height: 220px;
    }
}

.ingredients-button {
    display: flex;
    width: fit-content;
    border: 1px solid #2c3e50;
    padding: 4px;
    padding-left: 8px;
    padding-right: 8px;
    border-radius: 8px;
    cursor: pointer;
    margin-left: 14px;
    margin-bottom: 14px;
    font-weight: bold;
    font-size: 1.2rem;
    border: 1px solid rgb(0, 0, 0);
    color: rgb(0, 0, 0);
    margin: 0px;
}

.selected-ingredients {
    margin-top: 7px;
    padding: 7px 0 14px;

    text-align: left;
    font-weight: bold;
    font-size: 0.8rem;
    color: #000;
}

.selected-ingredients__title {
    color: #505050;
    font-weight: bold;
}

.dark {
    .selected-ingredients {
        color: #ffffff;
    }
}

.unchecked-mark {
    width: 20px;
    height: 20px;
    border: 1px solid black;
    border-radius: 100%;
}

.unchecked-mark, .checked-mark {
    margin-right: 10px;
}

.ingredient-button {
    .checked-mark {
        display: none;
    }
    .unchecked-mark {
        display: block;
    }
}

.ingredient-button.ingredient-button-selected {
    .checked-mark {
        display: block;
    }
    .unchecked-mark {
        display: none;
    }
}

.ingredients-section {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    flex-direction: column;
    max-height: 380px;
    overflow-x: auto;
}

.ingredients-section::-webkit-scrollbar {
    width: 0.2em;
}

.ingredients-sectionody::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.ingredients-section::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 1px solid slategrey;
}

.ingredient-box {
    position: relative;
    overflow: hidden;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;

    width: 30%;
    height: 170px;

    border: 1px solid #343434;
    border-radius: 6px;

    cursor: pointer;

    & img {
        max-width: 70px;
        width: 100%;
    }
}

.ingredient-box-selected {
    background: rgba(171, 35, 33, 0.2);

    .ingredient-box__content {
        box-shadow: 0 -5px 15px rgba(171, 35, 33, 0.2);
        background: rgba(171, 35, 33, 0.2);
    }
}

.ingredient-box__img {
    position: absolute;
    top: 22px;
    left: 50%;
    transform: translateX(-50%);

    width: 100%;
}

.ingredient-box__content {
    position: relative;
    z-index: 1;

    width: 100%;

    margin-top: 14px;
    padding: 6px 18px 12px;

    line-height: 140%;
    text-align: center;

    box-shadow: 0 -5px 15px rgb(255 255 255);
    background: rgba(255,255,255,0.9);
}

.dark {
    .ingredient-box__content {
        box-shadow: 0 -5px 15px #262323;
        background: rgba(38,35,35,0.9);
    }

    .ingredient-box-selected {
        .ingredient-box__content {
            box-shadow: 0 -5px 15px #26232340;
            background: rgba(38,35,35,0.2);
        }
    }
}

.ingredients__list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    width: 100%;

    margin-bottom: 24px;
    padding: 0;
}

.ingredients__item {
    margin: 0;
    font-size: 0.8rem;
}

.add-product-modal {
    .add-to-card-button {
        width: 100%;
        margin-top: 26px;

        &.make-order {
            width: auto;
        }
    }
}

@media only screen and (max-width: 1024px) {
    .make-order {
        display: inline-block;
    }

    .add-product-modal {
        height: 100%;
        width: 100%;
        overflow-y: auto;
        border-radius: unset;
        top: 0;
        left: 0;
        transform: unset;
        border: unset;
    }

    .add-product-modal-checkout-section {
        position: static;
    }
}

.dark {
    .add-product-modal-products {
        color: white;
    }

    .quanity-button--minus {
        color: white;
    }

    .size-box {
        background: #0C0C0C;
    }
    .size {
        background: #0C0C0C;
    }

    .unchecked-mark {
        border-color: white;
    }
}
</style>